import React, { useEffect } from 'react';
import { Grid, Box, Typography, TextField, FormControl, InputLabel, MenuItem, Select, Button, Card, CardMedia } from '@mui/material';
import './ProductScape.css';
import UploadImageCard from '../Reusable/UploadImageCard';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ReusableButton from '../Reusable/PrimaryButton/PrimaryButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Popup from '../Popup/Popup';
import { showToast } from '../Toast/CommonToast';
import { getModelName, uploadFile, enhancePrompt, getGeneratedImagesByEvent, generateCartoonImages, enhancePromptVariation } from '../../services/apiService';
import { useProductScapeSocket } from '../../context/ProductScapeWebsocket';
import LoaderWithBackdrop from '../Loader/loader';
import ErrorPopup from '../Popup/ErrorPopup/ErrorPopup';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AspectRatioBox from '../Reusable/AspectRatioDesign'; 
import { useCreditPoints } from '../../services/CreditPointsProvider';
import Masonry from "react-masonry-css";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import ExistingUploadImages from '../ExistingImageContainer/ExistingUploadImages';
interface ImageId {
  _id: string;
  url: string;
  caption: string;
  inputData?: {
    prompt?: string;
  };
    prompt?: string;
    usedPrompt?: string;
}

function ProductScape() {
    const [prompt, setPrompt] = React.useState<string>('');
    const [form, setForm] = React.useState({
        aspectRatio: '1:1',
    });
    const [draggedImage, setDraggedImage] = React.useState<any>(null);
    const [generateImage, setGenerateImage] = React.useState<any[]>([]);
    const [hoveredCard, setHoveredCard] = React.useState<number | null>(null);
    const [modelOpen, setModelOpen] = React.useState<boolean>(false);
    const [previewImage, setPreviewImage] = React.useState<any>({});
    const [modelDetails, setModelDetails] = React.useState<any>([])
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [previewImageUrl, setPreviewImageUrl] = React.useState<string>('');
    const [errorPopupOpen, setErrorPopupOpen] = React.useState({ open: false, message: "" });
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const { fetchCreditPoints } = useCreditPoints();
    const userId = localStorage.getItem('userId') || '';
    // originalImage
    const [originalImage, setOriginalImage] = React.useState<string>('');
    const [generatedImage, setGeneratedImage] = React.useState<string>('');
    const { responseData, reconnectWebSocket } = useProductScapeSocket();

    // socket response fetchingImage
useEffect(() => {
    if (responseData) {
        const responseArray = Array.isArray(responseData) ? responseData : [responseData];
        if (responseArray.length > 0) {
            setGenerateImage(prev => {
                const safePrev = Array.isArray(prev) ? prev : [];
                const allImages = [...responseArray, ...safePrev];
                
                // Simple deduplication by _id or url
                const uniqueImages = allImages.filter((img, index, arr) => 
                    arr.findIndex(item => 
                        (item._id && item._id === img._id) || 
                        (item.url && item.url === img.url)
                    ) === index
                );
                
                return uniqueImages;
            });
            
        }
        fetchCreditPoints(userId)
    }
}, [responseData, fetchCreditPoints, userId]);

    const handleDelete = () => {
        setDraggedImage(null);
        setPrompt('');
        setPreviewImageUrl('');
        setSelectedImageId(null);

    };
    const handleMouseEnter = (index: number) => {
        setHoveredCard(index);
    }
    const handleMouseLeave = () => {
        setHoveredCard(null);
    }
    const handleClickOpen = (item: any) => {
        setModelOpen(true);
        setGeneratedImage(item?.url || "");
        setOriginalImage(item?.inputData?.image_url || "");
        setPreviewImage({
            inputImage: item?.inputData?.image_url || "",
            generatedImage: item?.url || "",
            prompt: item?.prompt || ""
        });
    }
    const handleClose = () => {
        setModelOpen(false);
    }

    //    modelId getting here
    const modelId = modelDetails ? modelDetails.find((model: any) => model?.eventName === "Product Position")?._id || "684a5da3ed3f46be2271c921" : '';
    localStorage.setItem('productScapeModelId', modelId);





    // getModelName Api calling here
    const fetchModelname = async () => {
        try {
            const response = await getModelName('image');
            console.log("Model Name Response:", response);
            if (response && response.data) {
                setModelDetails(response.data);
            }
        } catch (error) {
            console.error("Error fetching model name:", error);
        }
    }



    // upload File api calling here
    const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsLoading(true);
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const fileArray = Array.from(files);
        fileArray.map((file) => URL.createObjectURL(file));

        const formData = new FormData();
        formData.append("files", files[0]);
        formData.append("userId", userId);
        formData.append("eventId", modelId);
        formData.append("isIdeaBoardImage", "true");

        try {
            const response = await uploadFile(formData);
            setIsLoading(false);
            if (response && response.status === "success") {
                const uploadedUrl = response?.data[0].url;
                showToast(response.message, "success");
                setPreviewImageUrl(uploadedUrl);
                setIsLoading(false);
                setPrompt(response?.data[0]?.caption || '');
            } else {
                setIsLoading(false);
                showToast(response.message, "error")
            }
        } catch (error: any) {
            setIsLoading(false);
            showToast(error.message, "error")
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    // enhace with ai button functionality
    const handleEnhanceWithAI = async () => {
        setIsLoading(true);
        try {
            const payloadEnhance = {
                prompt: prompt,
                // eventId: modelId
            }
            const response = await enhancePrompt(payloadEnhance);
            setIsLoading(false);
            if (response && response.status === "success") {
                setPrompt(response.data);
                showToast(response.message, "success");
            } else {
                showToast(response.message, "error");
                setIsLoading(false);
            }
        } catch (error: any) {
            setIsLoading(false);
            showToast(error.message, "error");
        }
    };
    const handleVariationWithAI = async () => {
        setIsLoading(true);
        try {
            const payloadVariation = {
                prompt: prompt,
                eventId: modelId,
                imageUrl: draggedImage || previewImageUrl
            }
            const response = await enhancePromptVariation(payloadVariation);
            setIsLoading(false);
            if (response && response.status === "success") {
                setPrompt(response.data);
                showToast(response.message, "success");
            } else {
                showToast(response.message, "error");
                setIsLoading(false);
            }
        } catch (error: any) {
            setIsLoading(false);
            showToast(error.message, "error");
        }
    };

    //  get Generated Images
    const getGeneratedImages = React.useCallback( async () => {
        try {
            const response = await getGeneratedImagesByEvent(userId, modelId);
            if (response && Array.isArray(response)) {
                setGenerateImage((prev) => {
                    const existingIds = new Set(prev.map((img) => img._id || img.url));
                    const uniqueNewImages = response.filter(
                        (img) => !existingIds.has(img._id || img.url)
                    );
                    return [...uniqueNewImages, ...prev];
                    
                });
            } else {
                console.error("Invalid response format or no data found.");
                setGenerateImage([]);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
            setGenerateImage([]);
        }
    }, [userId, modelId]);

        // useEffect
    useEffect(() => {
        fetchModelname();
        const fetchData = async () => {
            await getGeneratedImages();
           
        };
        fetchData();
    }, [modelId, userId, getGeneratedImages]);

    // handleGenerateImages api calling here
    const generateFetchImages = async () => {
        reconnectWebSocket(); //reconnect the websocket
        const payLoadImages = {
            userId: userId,
            eventId: modelId,
            imageUrl: draggedImage || previewImageUrl,
            prompt: prompt,
        };
        setIsLoading(true);
        try {
            const response = await generateCartoonImages(payLoadImages);
            setIsLoading(false);
            fetchCreditPoints(userId);
            const is404 = response?.statusCode === 404 || response?.errcode === "CRD404";
            const is403 = response?.statusCode === 403 || response?.errcode === "CRD403";
            if (response && response.status === "success") {
                const imageObject = response?.data?.imageGenerationId?.[0];
                if (imageObject) {
                    setGenerateImage((prev) => [imageObject, ...prev]);
                }
                setPrompt('');
                setPreviewImageUrl('');
                setDraggedImage(null);
            } else if (is404  || is403 || response?.errcode) {
                setErrorPopupOpen({
                    open: true,
                    message: response?.message || "Failed to generate image.",
                });
            } else {
                showToast(response?.message || "Failed to generate image.", "error");
            }
        } catch (error: any) {
            setIsLoading(false);
            showToast(error?.message || "Failed to generate image.", "error");
            setErrorPopupOpen({
                open: true,
                message: error?.message || "Failed to generate image.",
            });
        }
    };


    const [generatedViewType, setGeneratedViewType] = React.useState<'grid' | 'masonry'>('masonry');
  const [selectedImageId, setSelectedImageId] = React.useState<ImageId | null>(null);

 useEffect(()=>{
  if(selectedImageId) {
    setPreviewImageUrl(selectedImageId?.url || "");
    setPrompt(
      selectedImageId?.inputData?.prompt ||
      selectedImageId?.prompt ||
      selectedImageId?.usedPrompt ||
      selectedImageId?.caption ||
      ""
    );
  }
}, [selectedImageId, setPreviewImageUrl, setPrompt]);

    return (
         <Grid className='podcastContainer'>
            {isLoading && <LoaderWithBackdrop open={isLoading} />}
            {(errorPopupOpen.open && (errorPopupOpen.message === "Credits not found" || errorPopupOpen.message === "Insufficient credits")) && (
                <ErrorPopup
                    open={errorPopupOpen.open}
                    message={errorPopupOpen.message}
                    onClose={() => setErrorPopupOpen({ open: false, message: "" })}
                />
            )}
            <Typography variant="h1" className='studioNavHeading' gutterBottom>
                Productscape
            </Typography>
              <Grid container spacing={1} className='podcastMainContainer' sx={{
              gap: { xs: 0, sm: 0, md: 0 },
              padding: { xs: 0, sm: 0, md: 2 },
              margin: 0,
              width: '100%',
              flexWrap: 'wrap',
            }}>
                <Grid item xs={12} sm={6} md={5} className='podcastCardleft' sx={{ p: { xs: 0, sm: 0, md: 0 }, m: 0 }}>
                       <Box className='uploadImageContainer'>
                        <Box>
                                                        <Box
                                                            className='width100'
                                                            sx={{ height: '175px'}}
                                                            onDrop={async (e) => {
                                                                e.preventDefault();
                                                                try {
                                                                    const data = e.dataTransfer.getData('application/json');
                                                                    if (data) {
                                                                        const image = JSON.parse(data);
                                                                        setSelectedImageId(image);
                                                                        setDraggedImage(image.url);
                                                                        setPrompt(
                                                                            image.inputData?.prompt ||
                                                                            image.prompt ||
                                                                            image.usedPrompt ||
                                                                            image.caption ||
                                                                            ''
                                                                        );
                                                                    }
                                                                } catch (err) {
                                                                    // ignore
                                                                }
                                                            }}
                                                            onDragOver={e => e.preventDefault()}
                                                        >
                                                                <UploadImageCard
                                                                        image={draggedImage ? draggedImage : previewImageUrl}
                                                                        onDelete={() => handleDelete()}
                                                                        disabled={false}
                                                                        onUploadClick={handleUploadClick}
                                                                        onFileChange={handleUpload}
                                                                        fileInputRef={fileInputRef}
                                                                        selectedImageId={selectedImageId}
                                                                        setSelectedImageId={setSelectedImageId}
                                                                />
                                                        </Box>
                            <Box className='width100'>
                                <Box className='promptHeader'>
                                    <div className='promptHeaderText'>
                                        <img src={'/assets/scriptIcon.svg'} alt='scriptIcon' className='scriptIcon' />
                                        <Typography variant='h6' gutterBottom className='uploadText'>Describe your product image</Typography>
                                    </div>
                                    <div className='promptHeaderText' style={{marginBottom: '10px'}}>
                                        <ReusableButton icon={<AutoAwesomeIcon className="variationIcon" />} onClick={handleVariationWithAI} disabled={!prompt || !previewImageUrl }>Variant with AI</ReusableButton>
                                        <ReusableButton icon={<AutoAwesomeIcon className="enhanceIcon" />} onClick={handleEnhanceWithAI} disabled={!prompt || !previewImageUrl }>Enhance with AI</ReusableButton>
                                    </div>
                                </Box>
                                <TextField fullWidth className='textField' variant='outlined' label='Enhance your prompt with expressive details that match your product’s style...'
                                    value={prompt}
                                    multiline
                                    rows={prompt ? 4: 3}
                                    onChange={(e) => setPrompt(e.target.value)}
                                />
                            </Box>
                        </Box>
                        <div className='podcastButtonContainer '>
                            <Box className="aspectRatio width50 productScape">
                                <FormControl fullWidth className='textField'>
                                    <InputLabel>Aspect Ratio</InputLabel>
                                    <Select
                                        value={form.aspectRatio}
                                        onChange={e => setForm(f => ({ ...f, aspectRatio: e.target.value as string }))}
                                        label='Aspect Ratio'
                                        renderValue={(selected) => (
                                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            {selected}
                                          </Box>
                                        )}
                                    >
                                        <MenuItem value='1:1' className='selectBtn'>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AspectRatioBox ratio='1:1' isSelected={form.aspectRatio === '1:1'} />
        1:1
      </Box>
      {form.aspectRatio === '1:1' && <CheckCircleIcon color="success" fontSize="small" />}
    </Box>
  </MenuItem>
  <MenuItem value='16:9' className='selectBtn'>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AspectRatioBox ratio='16:9' isSelected={form.aspectRatio === '16:9'} />
        16:9
      </Box>
      {form.aspectRatio === '16:9' && <CheckCircleIcon color="success" fontSize="small" />}
    </Box>
  </MenuItem>
  <MenuItem value='9:16' className='selectBtn'>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AspectRatioBox ratio='9:16' isSelected={form.aspectRatio === '9:16'} />
        9:16
      </Box>
      {form.aspectRatio === '9:16' && <CheckCircleIcon color="success" fontSize="small" />}
    </Box>
  </MenuItem>
                                    </Select>
                                </FormControl>

                                {/* <Box className="countContainer">
                                    <Typography className="countText">{numberOfOutputs}</Typography>
                                    <Box className="buttonContainer">
                                        <Button
                                            style={{ backgroundColor: "#3e3e5f", minWidth: '30px' }}
                                            onClick={() => setNumberOfOutputs((prev) => Math.max(prev - 1, 1))}
                                            variant="contained"
                                        // sx={styles.button}
                                        >
                                            -
                                        </Button>
                                        <Button
                                            style={{ backgroundColor: "#3e3e5f", minWidth: '30px' }}
                                            onClick={() => setNumberOfOutputs((prev) => Math.min(prev + 1, 5))}
                                            variant="contained"
                                        // sx={styles.button}
                                        >
                                            +
                                        </Button>
                                    </Box>
                                </Box> */}
                            </Box>
                            <Box className='GenerateButtonContainer width50'>
                                <ReusableButton onClick={generateFetchImages} disabled={!prompt || !previewImage ||!draggedImage}>
                                    Generate (25 Credits)
                                </ReusableButton>
                            </Box>
                        </div>

                           <Box className="podcastUpload-Container productScape">
                            <ExistingUploadImages modelId={modelId} setImage={setDraggedImage} setPrompt={setPrompt} />
                            </Box>
                    </Box>

                </Grid>
                <Grid item xs={12} sm={6} md={7} className='podcastCardRight' sx={{ p: { xs: 0, sm: 0, md: 0 }, m: 0 }}>
                    <Box className="generated-Images" sx={{ height: '100%', overflowY: 'auto', pl: 1 }}>
                        <Box className="backgroundColor-2D3157 position-sticky" sx={{ display: 'flex', gap: 2,  justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" gutterBottom className="subTitle">
                                Generated Images
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {generatedViewType === "masonry" ?
                                    <ViewModuleIcon className="iconColor" onClick={() => setGeneratedViewType('grid')} /> :
                                    <ViewQuiltIcon className="iconColor" onClick={() => setGeneratedViewType('masonry')} />
                                }
                            </Box>
                        </Box>
                        {generatedViewType === 'grid' ? (
                            <Grid container spacing={1}>
                                {Array.isArray(generateImage) && generateImage.length > 0 ? (
                                    generateImage.map((item: any, index: number) => {
                                        const imageUrl = item?.url;
                                        return (
                                            <Grid item xs={6} sm={6} md={3} lg={3} key={item._id || index}>
                                                <Card
                                                    onMouseEnter={() => handleMouseEnter(index)}
                                                    onMouseLeave={handleMouseLeave}
                                                    className="generate-card"
                                                >
                                                    <CardMedia
                                                        component="img"
                                                        image={imageUrl}
                                                        alt={`Generated Image ${index}`}
                                                        className={`${item.isGenerated ? "generate-Image-cards" : "generate-blur-card"}`}
                                                    />
                                                    {hoveredCard === index && item.isGenerated && (
                                                        <Box className="hoverbtn-cartoon">
                                                            <Button
                                                                className="previewButton"
                                                                onClick={() => handleClickOpen(item)}
                                                                sx={{ color: "#fff" }}
                                                            >
                                                                <VisibilityIcon className="iconColor" />
                                                                <Typography className="previewText">Preview</Typography>
                                                            </Button>
                                                        </Box>
                                                    )}
                                                </Card>
                                            </Grid>
                                        );
                                    })
                                ) : (
                                    <Grid item xs={12}>
                                        <Typography variant="body1" className="no-image-text">
                                            No images generated yet.
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        ) : (
                            <Masonry
                                breakpointCols={{ default: 4, 1100: 3, 700: 3, 500: 2}}
                                className="my-masonry-grids"
                                columnClassName="my-masonry-grid_column"
                            >
                                {Array.isArray(generateImage) && generateImage.length > 0 ? (
                                    generateImage.map((item: any, index: number) => {
                                        const imageUrl = item?.url;
                                        
                                        return (
                                            <Card
                                                key={item._id || index}
                                                onMouseEnter={() => handleMouseEnter(index)}
                                                onMouseLeave={handleMouseLeave}
                                                className="generate-card"
                                            >
                                                <CardMedia
                                                    component="img"
                                                    image={imageUrl}
                                                    alt={`Generated Image ${index}`}
                                                    className={`${item.isGenerated ? "generate-Image-cards" : "generate-blur-card"}`}
                                                />
                                                {hoveredCard === index && item.isGenerated && (
                                                    <Box className="hoverbtn-cartoon">
                                                        <Button
                                                            className="previewButton"
                                                            onClick={() => handleClickOpen(item)}
                                                            sx={{ color: "#fff" }}
                                                        >
                                                            <VisibilityIcon className="iconColor" />
                                                            <Typography className="previewText">Preview</Typography>
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Card>
                                        );
                                    })
                                ) : (
                                    <Typography variant="body1" className="no-image-text">
                                        No images generated yet.
                                    </Typography>
                                )}
                            </Masonry>
                        )}
                        {/* modelOpen */}
                        {modelOpen && (
                            <Popup
                                open={modelOpen}
                                onClose={handleClose}
                                leftColumnType="both"
                                leftImageSrc={previewImage?.inputImage}
                                rightColumnType="slider"
                                originalImage={originalImage}
                                generatedImage={generatedImage}
                                leftPromptText={previewImage?.prompt}
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>
            </Grid>
    );
}

export default ProductScape;
